import { render, staticRenderFns } from "./MDISVG.vue?vue&type=template&id=65423fbc&"
import script from "./MDISVG.vue?vue&type=script&lang=js&"
export * from "./MDISVG.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports